import type { Provider } from 'react';
import { createContext, useContext } from 'react';

const FeatureConfigContext = createContext({});

export const FeatureConfigProvider = FeatureConfigContext.Provider;

export const useFeatureConfig = <Config,>(): Config => {
    const config = useContext(FeatureConfigContext);

    if (Object.keys(config).length === 0) {
        throw new Error('useFeatureConfig must be used within the FeatureConfigProvider');
    }

    return config as Config;
};

export function createFeatureConfig<Config>(): [() => Config, Provider<Partial<Config>>] {
    return [useFeatureConfig<Config>, FeatureConfigProvider];
}
